import { render, staticRenderFns } from "./painel_envio.vue?vue&type=template&id=f0853dde&"
import script from "./painel_envio.vue?vue&type=script&lang=js&"
export * from "./painel_envio.vue?vue&type=script&lang=js&"
import style0 from "./painel_envio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0853dde')) {
      api.createRecord('f0853dde', component.options)
    } else {
      api.reload('f0853dde', component.options)
    }
    module.hot.accept("./painel_envio.vue?vue&type=template&id=f0853dde&", function () {
      api.rerender('f0853dde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/arquivo/painel_envio.vue"
export default component.exports